import { render, staticRenderFns } from "./PageLayout.vue?vue&type=template&id=422fd402&"
import script from "./PageLayout.vue?vue&type=script&lang=ts&"
export * from "./PageLayout.vue?vue&type=script&lang=ts&"
import style0 from "./PageLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports